//natives
import React, { Component } from 'react';
import { registerLocale } from "react-datepicker";
import pt from "date-fns/locale/pt";
registerLocale("pt", pt);
import dateFormat from 'dateformat';
import Cookies from 'universal-cookie';
import FilterForm from '../childrens/filterForm/.mixins';

//controllers
import Config from '../../../../controllers/config';
import Pessoas_controller from '../../../../controllers/pessoa';
import { AuthContext } from '../../../../contexts/AuthContext';

export default class Filter extends Component {
    static contextType = AuthContext;
    
    constructor(props) {
        super(props);

        this.permissions = {};
        
        var d = new Date();
        d.setDate(d.getDate() - 30);

        this.state = {
            dataInicio: d,
            dataFim:  new Date(),
            fornecedores: null
        }

        this.setState = this.setState.bind(this);
        this.sendRequest = this.sendRequest.bind(this);

        if (this.props.state.filters.adminFilter != 0)
            this.loadFornecedores(this);
    }
    
    componentDidMount() {
        this.permissions = this.context.user.permissions;
    }
    
    async sendRequest(props) {

        var filters = {
            dataInicio: props.state.dataInicio?dateFormat(props.state.dataInicio, "yyyy-mm-dd" ):null,
            dataFim: props.state.dataFim?dateFormat(props.state.dataFim, "yyyy-mm-dd" ):null
        }

        if (filters.dataInicio == null) {
            props.props.child.current.retorno("Data de início deve ser preenchida!",'error');
            return;
        }

        if (filters.dataFim == null) {
            props.props.child.current.retorno("Data de fim deve ser preenchida!",'error');
            return;
        }
        
        await this.props.setState({
            current_page: 1
        });
        
        props.props.loadData(filters);

    }

    async loadFornecedores(props) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {
            const r_fornecedores = await Pessoas_controller.getFornecedores(token);
            const j_r_fornecedores = JSON.parse(r_fornecedores.body);
            if (r_fornecedores.res.statusCode === 200) {
                props.setState({
                    fornecedores: j_r_fornecedores.itens,
                });
            } else {
                if (
                    j_r_fornecedores.status == false && 
                    j_r_fornecedores.message && 
                    j_r_fornecedores.message.includes("Token inválido!")
                ) {
                    props.props.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
            errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });
            props.props.child.current.retorno(error.message,'error');
        }

    }

    render() {
        return (<FilterForm {...this}/>);
    }
}